import { FC } from "react";
import { Drawer } from "antd";
import TagList from "./MainSection/TagList";
import Filters from "./MainSection/Filters";

interface Props {
  open: boolean;
  onClose: () => void;
}

const FilterDrawer: FC<Props> = ({ open, onClose }) => {
  return (
    <Drawer
      title={<b>Filter Hackathon</b>}
      width={375}
      visible={open}
      onClose={onClose}
    >
      <TagList />
      <Filters />
    </Drawer>
  );
};

export default FilterDrawer;
